import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IPresentation } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { presentationColumns } from "./components/presentationColumns";
import { presentationSearchFields } from "./components/presentationSearchFields";

export const PresentationList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IPresentation>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="시설 설명회 공지 목록"
            />

            <SearchToolbar
                fields={presentationSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={presentationColumns}
                isError={tableQueryResult.isError}
                errorMessage="설명회 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 설명회가 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                getRowShowPath={(row) => `/presentations/show/${row.id}`}
            />
        </List>
    );
};
